import { NumberFormat } from '@billy/design-system'

export const getFormattedTickValue = (value: number, locale = 'nl_NL'): string => {
  return NumberFormat.getFormattedNumber(value, locale, { notation: 'compact' })
}
